<template>
  <SimpleProductPage v-if="isSimpleProduct" />
  <ProductPageMain v-else />

  <div v-if="enableRelatedProducts" class="container">
    <RelatedProducts />
  </div>
</template>

<script lang="ts" setup>
import RelatedProducts from '@/pages/ProductPage/partials/RelatedProducts.vue';
import { MediaclipProductType } from '@/types/Mediaclip/MediaclipProductType.ts';
import ProductPageMain from '@/pages/ProductPage/ProductPageMain.vue';
import SimpleProductPage from '@/pages/ProductPage/SimpleProductPage.vue';

const isSimpleProduct =
  window.product.mediaclip_product_type == MediaclipProductType.NONE;

const enableRelatedProducts = window.enable_related_products;
</script>
